import { useEffect, useState } from 'react';

import './Carousel.css';

function CarouselItem({ activeItem, isAnimationPaused }) {
  const [fadeOut, setFadeOut] = useState<string>();

  useEffect(() => {
    const interval = setInterval(() => {
      setFadeOut('fadeOut');
    }, 3500);
    return () => {
      if (interval) {
        clearInterval(interval);
        setFadeOut('');
      }
    };
  }, []);

  return (
    activeItem && (
      <div className={`tiles_container ${isAnimationPaused ? 'no-animation' : ''}`}>
        {activeItem.images.map((image, index) => (
          <img
            key={index}
            className={`tile${index} ${fadeOut}`}
            src={image.src}
            alt={`${image.alt}`}
          />
        ))}
      </div>
    )
  );
}

export default CarouselItem;
